// extracted by mini-css-extract-plugin
module.exports = {"modal":"LostPasswordModal_modal__2DdEQ","check":"LostPasswordModal_check__3963G"};